import { useCallback, useEffect, useState } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { getAreaAnalysis } from "../api/heat-map.api";
import type { AreaAnalysisModel } from "../types/AreaAnalysis";
import type { DashboardFilterPayload } from "../utils/heat-map.utils";

export const useAreaAnalysis = (payload: DashboardFilterPayload) => {
  const [data, setData] = useState<AreaAnalysisModel[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { run: runLatestRequest, loading } = useLatestRequest();

  const fetchData = useCallback(async () => {
    try {
      setError(null);
      const result = await runLatestRequest((signal) => getAreaAnalysis(payload, signal));

      if (!result) return undefined;

      setData(result);
      return result;
    } catch (fetchError) {
      setData(null);
      setError(getApiErrorMessage(fetchError, "Failed to load area analysis"));
      return undefined;
    }
  }, [payload, runLatestRequest]);

  useEffect(() => {
    void fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};
